import moment, { duration } from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

export const formatFinValidite = (value: Date|string, dureeM:number, format:string='DD/MM/YYYY HH:mm',i18n:VueI18n|null=null,utc:boolean=false) => {
  if (value) {    
    moment.locale(i18n?.locale??"fr")       
    return (utc?moment(String(value)).utc():moment(String(value))).add(dureeM,'M').format(format)
  }
  return ""
}

export const isValide = (value: Date|string, dureeM:number, format:string='DD/MM/YYYY HH:mm') => {
  if (value) {    
    moment.locale("fr")   
    return moment(String(value)).add(dureeM,'M').diff(moment()) > 0    
  }
  return false
}

Vue.filter('formatFinValidite',formatFinValidite)